

@if(pdfPreviewUrl != undefined){
<div class="container-full" style="position:relative;top:-15px;">
    <div class="row">
        @if(isNotificationSent){
            <div class="col-12" style="display:flex;justify-content:center;align-items:center;margin-top:2px;height:105px;width:100%;text-align:center;">
                        <span style="font-size:18px;font-weight:bold;">The invoice has been emailed.</span>
            </div>
        }
        @if(isFinalzing){
            <div class="loading-wrap">
                <div class="loading-content">
                    <mat-progress-bar class="invoice-progress" mode="indeterminate"></mat-progress-bar>
                    <span class="loading-label"><strong>Finalizing Invoice...</strong></span>
                </div>
            </div>
        }
        @if(!isInvoiceFinalized){
            <div class="col-12" style="display:flex;justify-content:center;margin-top:10px;height:105px;">
               
                    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;height:40px;" 
                            (click)="onFinalizeInvoice()"
                            [disabled]="isInvoiceFinalized">
                        Finalize Invoice
                    </button>
                  
            </div>
        }

        @if(isInvoiceFinalized)
        {
            @if(isNotificationSent == false && isCapableOfSendingEmail)
            {
                <div class="col-12" style="display:flex;justify-content:center;margin-top:10px;height:105px;">
                    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;height:40px;" 
                            (click)="onSendInvoice()"
                            [disabled]="!isInvoiceFinalized">
                        Send Invoice</button>
                </div>
            }

            @if(!isCapableOfSendingEmail)
            {
                 <div class="col-12" style="display:flex;justify-content:center;margin-top:30px;height:105px;">
                    <span style="font-size:18px;font-weight:bold;">Email Address Or Delivery Type Set to Print for this customer</span>
                </div>
            }
           
        }


        
    </div>
</div>
<div style="margin-top:2px;height:100%;width:100%;position:relative;top:-4%;">
<iframe
    [src]="pdfPreviewUrl"
    frameBorder="0"
    scrolling="auto"
    height="100%"
    width="100%"
></iframe>
</div>
}
@else {
    <div class="loading-wrap">
        <div class="loading-content">
            <mat-progress-bar class="invoice-progress" mode="indeterminate"></mat-progress-bar>
            <span class="loading-label"><strong>Preparing Invoice...</strong></span>
        </div>
    </div>
}
